/*---------------------------------------------------------------------------------------------
* Copyright (c) Bentley Systems, Incorporated. All rights reserved.
* See LICENSE.md in the project root for license terms and full copyright notice.
*--------------------------------------------------------------------------------------------*/

import { SandboxList } from "components/sandboxes-list/SandboxList";
import { useComponentEngagement } from "hooks/useComponentEngagement";
import { useEffect } from "react";
import { actionItemsAdded, selectCurrentUser } from "store/features";
import { useAppDispatch, useAppSelector } from "store/hooks";

export const SandboxesView = () => {
  const user = useAppSelector(selectCurrentUser);
  const dispatch = useAppDispatch();

  useComponentEngagement("Sandboxes");

  useEffect(() => {
    dispatch(actionItemsAdded(["create", "shareIdea"]));
  }, [dispatch]);

  if (!user)
    return null;

  return <SandboxList user={user} />;
};
